import React from 'react';

// Un seul mot en degrade par titre, comme le veut la charte.
// Pas de surtitre : le titre se suffit a lui-meme.
export default function TitreSection({ avant, mot, apres, clair = false, centre = false }) {
  return (
    <div className={centre ? 'text-center max-w-2xl mx-auto' : 'max-w-3xl'}>
      <h2 className={`titre-section ${clair ? 'text-white' : 'text-nuit'}`}>
        {avant}
        {mot && <span className="mot-degrade">{mot}</span>}
        {apres}
      </h2>
    </div>
  );
}
